/*
  Bridal (round 55, made grand in round 56): the opening's beats and its air, the boxes that open, the shelves that
  move sideways, and the parts below rising into place (sections/vr-bridal.liquid, vr-bridal-days.liquid,
  vr-bridal-shelves.liquid, vr-bridal-close.liquid; styles in assets/vr-bridal.css).
  - The opening, once the middle bride's photograph is there (or after two and a half seconds whatever happens): the
    doves and the small line; the toran is hung (its bells swing once) and the marigolds are let down at either side;
    the gold lines trace the arches, and while they do the arches are lit from the outer two inwards, each with its
    diyas (round 61, the owner: the first as the lines begin, the last as they end); then the name, its line and the
    links, and a shower of rose and marigold petals that settles at the foot. Each beat ends before the next begins
    (the lines and the lights, together, are one), and the strings swing less and less until they hang still.
  - The air (the marigolds and the petals) is drawn on a canvas over the facade: each marigold is drawn once, petal by
    ruffled petal, and stamped along the strings; the petals are those of the Offers page (assets/vr-offers.js), with
    marigold petals among the roses. Drawing stops when everything has come to rest, or while the opening is out of
    view.
  - Opened further down the page, or with reduced motion asked for, the opening is shown lit and still.
  - A box below the first screen opens when it comes into view: the lid rises and the pieces are laid out.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* the beats, in milliseconds from the start. The gold lines trace the arches from DRAWN for DRAWING (1.8 s, the
     inner line a quarter of a second behind: assets/vr-bridal.css); the arches are lit in turn while they do, each
     veil lifting for LIFT, the first as the lines begin and the last ending as they end (the outer two arches only
     where they are shown, on wide screens); then the name, and the petals after it */
  var DRAWN = 1400, DRAWING = 2050, LIFT = 800, SHOWER_AFTER = 900;
  function beatsFor(outer) {
    var lamps = outer ? ['is-lit-o', 'is-lit-l', 'is-lit-r', 'is-lit-c'] : ['is-lit-l', 'is-lit-r', 'is-lit-c'];
    var b = [['is-head', 0], ['is-hung', 500], ['is-drawn', DRAWN]];
    if (!outer) b.push(['is-lit-o', DRAWN]);
    lamps.forEach(function (c, i) { b.push([c, DRAWN + Math.round(i * (DRAWING - LIFT) / (lamps.length - 1))]); });
    b.push(['is-told', DRAWN + DRAWING + 150]);
    return b;
  }

  function rand(a, b) { return a + Math.random() * (b - a); }
  function mix(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t]; }
  function rgb(c) { return 'rgb(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ')'; }

  /* ---------------- the air: marigold strings and petals ---------------- */

  /* one marigold, px across: a dome of ruffled petals in rings, lit from the upper left, its shadow baked below it */
  var TONES = {
    o: { lo: [140, 52, 2], base: [232, 122, 16], hi: [255, 186, 70] },
    y: { lo: [150, 80, 4], base: [236, 160, 24], hi: [255, 222, 92] },
    d: { lo: [118, 34, 2], base: [214, 92, 10], hi: [255, 160, 60] }
  };
  function marigold(px, tone) {
    var pad = Math.round(px * 0.18);
    var c = document.createElement('canvas');
    c.width = px + pad * 2; c.height = px + pad * 2;
    var g = c.getContext('2d');
    var cx = c.width / 2, cy = c.height / 2, R = px * 0.44, T = TONES[tone];
    var col = function (k) { var a = k < 0.5 ? T.lo : T.base, b = k < 0.5 ? T.base : T.hi, t = k < 0.5 ? k / 0.5 : (k - 0.5) / 0.5; return rgb(mix(a, b, t)); };
    /* the shadow it casts, a little below */
    var sh = g.createRadialGradient(cx, cy + px * 0.1, R * 0.3, cx, cy + px * 0.1, R * 1.25);
    sh.addColorStop(0, 'rgba(0,0,0,0.5)'); sh.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = sh; g.fillRect(0, 0, c.width, c.height);
    /* a dark body, so the gaps between petals read as depth */
    var body = g.createRadialGradient(cx - R * 0.3, cy - R * 0.35, R * 0.1, cx, cy, R);
    body.addColorStop(0, col(0.55)); body.addColorStop(1, col(0.08));
    g.fillStyle = body; g.beginPath(); g.arc(cx, cy, R * 0.92, 0, Math.PI * 2); g.fill();
    var layers = 11;
    for (var L = 0; L < layers; L++) {
      var t = L / (layers - 1), r = R * (0.98 - t * 0.9);
      var n = Math.max(5, Math.round((2 * Math.PI * Math.max(r, R * 0.08)) / (px * 0.06)));
      for (var i = 0; i < n; i++) {
        var a = (i / n) * Math.PI * 2 + rand(-0.2, 0.2) + L * 0.5, rr = r * rand(0.88, 1.04);
        var x = cx + Math.cos(a) * rr, y = cy + Math.sin(a) * rr;
        var nx = (x - cx) / R, ny = (y - cy) / R;
        var k = Math.max(0, Math.min(1, 0.6 - 0.32 * nx - 0.42 * ny + 0.12 * (1 - t) + rand(-0.12, 0.12)));
        var len = px * rand(0.07, 0.11) * (1 - t * 0.3), wid = px * rand(0.06, 0.09) * (1 - t * 0.25);
        g.save(); g.translate(x, y); g.rotate(a + Math.PI / 2 + rand(-0.4, 0.4));
        g.beginPath(); g.moveTo(-wid * 0.3, len * 0.5); g.lineTo(-wid * 0.5, -len * 0.1);
        for (var q = 0; q <= 4; q++) { var qx = -wid * 0.5 + (q / 4) * wid; g.quadraticCurveTo(qx - wid / 8, -len * (0.62 + rand(-0.1, 0.12)), qx, -len * 0.45); }
        g.lineTo(wid * 0.3, len * 0.5); g.closePath();
        var pg = g.createLinearGradient(0, len * 0.5, 0, -len * 0.6);
        pg.addColorStop(0, col(k * 0.45)); pg.addColorStop(0.7, col(k)); pg.addColorStop(1, col(Math.min(1, k + 0.18)));
        g.fillStyle = pg; g.fill();
        g.strokeStyle = 'rgba(90,30,0,' + (0.25 + 0.25 * (1 - k)).toFixed(2) + ')'; g.lineWidth = px * 0.006; g.stroke();
        g.restore();
      }
    }
    /* the night it hangs in: a touch darker than in daylight */
    g.globalCompositeOperation = 'source-atop';
    var dim = g.createLinearGradient(0, cy - R, 0, cy + R);
    dim.addColorStop(0, 'rgba(20,8,0,0.04)'); dim.addColorStop(1, 'rgba(20,8,0,0.26)');
    g.fillStyle = dim; g.fillRect(0, 0, c.width, c.height);
    c.pad = pad;
    return c;
  }
  /* the gold tassel at the end of a string */
  function tassel(px) {
    var c = document.createElement('canvas');
    c.width = px; c.height = Math.round(px * 1.6);
    var g = c.getContext('2d'), cx = px / 2;
    var gold = g.createLinearGradient(0, 0, px, 0);
    gold.addColorStop(0, '#7a560f'); gold.addColorStop(0.5, '#f2d88e'); gold.addColorStop(1, '#8a6312');
    g.fillStyle = gold;
    g.beginPath(); g.arc(cx, px * 0.16, px * 0.13, 0, Math.PI * 2); g.fill();
    g.beginPath(); g.moveTo(cx - px * 0.16, px * 0.3); g.quadraticCurveTo(cx, px * 0.22, cx + px * 0.16, px * 0.3); g.lineTo(cx + px * 0.12, px * 0.42); g.lineTo(cx - px * 0.12, px * 0.42); g.closePath(); g.fill();
    g.strokeStyle = gold; g.lineWidth = Math.max(1, px * 0.035);
    for (var i = -3; i <= 3; i++) { g.beginPath(); g.moveTo(cx + i * px * 0.025, px * 0.42); g.lineTo(cx + i * px * 0.07, px * 1.5); g.stroke(); }
    return c;
  }

  /* a rose petal (as on the Offers page) or a marigold petal, base at the bottom, no two alike */
  var ROSES = [
    [[228, 88, 110], [178, 32, 58], [104, 12, 30]],
    [[222, 86, 132], [166, 28, 84], [94, 10, 48]],
    [[200, 56, 66], [140, 22, 36], [76, 8, 20]]
  ];
  var MARIGOLDS = [
    [[255, 196, 80], [236, 128, 20], [150, 60, 4]],
    [[255, 224, 110], [240, 170, 30], [160, 96, 6]]
  ];
  function roseForm() {
    var wd = rand(0.74, 1), notch = rand(0.03, 0.16), lean = rand(-0.12, 0.12), top = rand(0.94, 1.06);
    var p = new Path2D();
    p.moveTo(0, 1);
    p.bezierCurveTo(-0.5 * wd, 0.84, -1.04 * wd, 0.16, -0.88 * wd + lean, -0.5);
    p.bezierCurveTo(-0.74 * wd + lean, -0.94 * top, -0.3 * wd + lean, -1.04 * top, lean * 0.6, -0.9 * top + notch);
    p.bezierCurveTo(0.3 * wd + lean, -1.04 * top, 0.74 * wd + lean, -0.94 * top, 0.88 * wd + lean, -0.5);
    p.bezierCurveTo(1.04 * wd, 0.16, 0.5 * wd, 0.84, 0, 1);
    p.closePath();
    return p;
  }
  function marigoldForm() {
    var wd = rand(0.55, 0.8), p = new Path2D(), q;
    p.moveTo(0, 1);
    p.bezierCurveTo(-0.4 * wd, 0.72, -0.92 * wd, 0.1, -0.86 * wd, -0.56);
    for (q = 0; q < 4; q++) {
      var x0 = -0.86 * wd + (q / 4) * 1.72 * wd, x1 = -0.86 * wd + ((q + 1) / 4) * 1.72 * wd;
      p.quadraticCurveTo((x0 + x1) / 2, -0.98 - rand(0, 0.14), x1, -0.6 + rand(-0.06, 0.06));
    }
    p.bezierCurveTo(0.92 * wd, 0.1, 0.4 * wd, 0.72, 0, 1);
    p.closePath();
    return p;
  }

  function Air(sec) {
    var cv = sec.querySelector('[data-vrb-air]');
    if (!cv || !cv.getContext || typeof window.Path2D !== 'function') return null;
    var g = cv.getContext('2d');
    var W = 0, H = 0, dpr = 1, cordY = 7, SZ = 30, floorY = 0;
    var strands = [], air = [], landed = [], sprites = null, tas = null;
    var hungAt = -1, showerAt = -1, spawned = 0, total = 0, lastSpawn = 0;
    var raf = 0, running = false, visible = true, still = false, rested = false;

    function measure() {
      var rect = sec.getBoundingClientRect();
      var oldW = W;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      W = cv.clientWidth; H = cv.clientHeight;
      cv.width = Math.max(1, Math.round(W * dpr)); cv.height = Math.max(1, Math.round(H * dpr));
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      var sz = W < 750 ? 22 : W < 1200 ? 26 : 30;
      if (!sprites || sz !== SZ) {
        SZ = sz;
        sprites = { o: marigold(SZ * 2, 'o'), y: marigold(SZ * 2, 'y'), d: marigold(SZ * 2, 'd') };
        tas = tassel(SZ * 2);
      }
      var tor = sec.querySelector('.vrb-toran__svg');
      if (tor) { var tr = tor.getBoundingClientRect(); cordY = tr.top - rect.top + (tr.height * 7) / 64; }
      var lo = W, hi = 0, arches = sec.querySelectorAll('.vrb-trip__arch');
      for (var i = 0; i < arches.length; i++) {
        var a = arches[i].getBoundingClientRect();
        if (!a.width) continue;
        lo = Math.min(lo, a.left - rect.left); hi = Math.max(hi, a.right - rect.left);
      }
      var trip = sec.querySelector('.vrb-trip');
      var tb = trip ? trip.getBoundingClientRect().bottom - rect.top : H * 0.7;
      floorY = H - 4;
      /* the strings, in the spaces either side of the facade: longest at the edge of the page, shorter towards it */
      strands = [];
      var side = Math.min(lo, W - hi);
      var room = side - 24;
      var n = Math.min(5, Math.floor(room / (SZ * 1.9)));
      if (n >= 1) {
        var gap = n > 1 ? Math.min(SZ * 2.3, (room - SZ) / (n - 1)) : 0;
        for (var k = 0; k < n; k++) {
          var x = 14 + SZ / 2 + k * gap + (n === 1 ? (room - SZ) / 2 : 0);
          var len = Math.max(SZ * 4, (tb - cordY) * (0.94 - 0.15 * k));
          for (var sdir = 0; sdir < 2; sdir++) {
            strands.push({ x: sdir ? W - x : x, len: len, ph: rand(0, 6.3), w: rand(1.9, 2.5), amp: rand(0.045, 0.065), pat: (k + sdir) % 2 ? ['o', 'y'] : ['y', 'o'], seed: rand(0, 10) });
          }
        }
      }
      if (oldW && Math.abs(W - oldW) > 1) { for (var m = 0; m < landed.length; m++) landed[m].x = landed[m].fx * W; }
      total = Math.max(14, Math.min(34, Math.round(W / 48)));
    }

    function drawStrands(t) {
      var step = SZ * 0.74;
      for (var s = 0; s < strands.length; s++) {
        var st = strands[s];
        var f = t < 0 ? 0 : Math.min(1, t / 1.3);
        var reveal = 1 - Math.pow(1 - f, 3);
        var th = t < 0 || still ? 0 : st.amp * Math.exp(-Math.max(0, t - 0.5) / 3.2) * Math.sin(st.w * t + st.ph) * Math.min(1, t / 0.9);
        var shown = st.len * reveal;
        var nb = Math.floor(shown / step);
        if (nb < 1) continue;
        /* the thread */
        g.strokeStyle = 'rgba(214, 182, 100, 0.5)'; g.lineWidth = 1;
        g.beginPath(); g.moveTo(st.x, cordY);
        var px = st.x, py = cordY;
        for (var k = 1; k <= nb; k++) {
          var d = k * step, a = th * (0.45 + (0.55 * d) / st.len);
          px = st.x + Math.sin(a) * d; py = cordY + Math.cos(a) * d;
          g.lineTo(px, py);
        }
        g.stroke();
        for (var b = 1; b <= nb; b++) {
          var dd = b * step, aa = th * (0.45 + (0.55 * dd) / st.len);
          var bx = st.x + Math.sin(aa) * dd, by = cordY + Math.cos(aa) * dd;
          var sp = sprites[(b + Math.round(st.seed)) % 7 === 0 ? 'd' : st.pat[b % 2]];
          var size = SZ * (0.94 + 0.08 * Math.sin(b * 2.1 + st.seed));
          var full = size * (sp.width / (sp.width - sp.pad * 2));
          g.save(); g.translate(bx, by); g.rotate(b * 1.7 + st.seed);
          g.drawImage(sp, -full / 2, -full / 2, full, full);
          g.restore();
        }
        if (reveal >= 1) {
          var tw = SZ * 0.8;
          g.save(); g.translate(px, py + SZ * 0.42); g.rotate(-th * 1.1);
          g.drawImage(tas, -tw / 2, 0, tw, tw * 1.6);
          g.restore();
        }
      }
    }

    function petal() {
      var depth = Math.random(), rose = Math.random() < 0.7;
      return {
        x: rand(-0.02, 1.02) * W, y: rand(-80, -20),
        size: (rose ? 6.6 + depth * 8.4 : 4.6 + depth * 5) * Math.max(0.78, Math.min(1, W / 1200)),
        speed: 24 + depth * 22, sway: rand(10, 30), swaySpeed: rand(0.22, 0.5), phase: rand(0, 6.3),
        rot: rand(0, 6.3), rotSpeed: rand(-0.7, 0.7), flip: rand(0, 6.3), flipSpeed: rand(0.5, 1.3),
        alpha: 0.82 + depth * 0.18,
        tones: rose ? ROSES[Math.floor(Math.random() * ROSES.length)] : MARIGOLDS[Math.floor(Math.random() * MARIGOLDS.length)],
        path: rose ? roseForm() : marigoldForm(), rest: 0, t0: 0
      };
    }
    function paint(p, x, y, lit, flat) {
      var t = p.tones, k = 0.5 + lit * 0.5;
      g.save();
      g.translate(x, y);
      if (flat) g.scale(1, flat);
      g.rotate(p.rot);
      g.scale(p.size * Math.max(0.14, lit), p.size);
      var grad = g.createLinearGradient(0, 1, 0, -1);
      grad.addColorStop(0, rgb(mix(t[2], t[1], 0.3 * k)));
      grad.addColorStop(0.5, rgb(mix(t[2], t[1], k)));
      grad.addColorStop(1, rgb(mix(t[1], t[0], k * 0.85)));
      g.globalAlpha = p.alpha;
      g.fillStyle = grad;
      g.fill(p.path);
      g.restore();
    }

    function frame(now) {
      raf = 0;
      if (!running) return;
      var tHung = hungAt < 0 ? -1 : (now - hungAt) / 1000;
      g.clearRect(0, 0, W, H);
      drawStrands(tHung);
      /* the shower: a petal at a time until all have fallen; each lands at the foot and stays */
      if (showerAt >= 0) {
        var dt = Math.min(0.05, (now - (frame.last || now)) / 1000);
        if (spawned < total && now - lastSpawn > 240) { air.push(petal()); spawned++; lastSpawn = now; }
        for (var i = air.length - 1; i >= 0; i--) {
          var p = air[i];
          p.y += p.speed * dt; p.phase += p.swaySpeed * dt; p.rot += p.rotSpeed * dt; p.flip += p.flipSpeed * dt;
          var x = p.x + Math.sin(p.phase * 6.28) * p.sway * 0.4;
          if (p.y >= floorY - rand(0, 14)) {
            p.x = x; p.fx = x / W; p.y = Math.min(p.y, floorY); p.lit = Math.abs(Math.cos(p.flip)); p.flat = rand(0.42, 0.62);
            landed.push(p); air.splice(i, 1);
            continue;
          }
          paint(p, x, p.y, Math.abs(Math.cos(p.flip)), 0);
        }
      }
      for (var j = 0; j < landed.length; j++) { var r = landed[j]; paint(r, r.x, r.y, Math.max(0.5, r.lit), r.flat); }
      frame.last = now;
      var swinging = hungAt >= 0 && tHung < 14;
      var falling = showerAt >= 0 && (spawned < total || air.length > 0);
      if (swinging || falling) raf = window.requestAnimationFrame(frame);
      else { running = false; rested = true; }
    }
    function start() {
      if (running || still || rested || !visible || document.hidden || (hungAt < 0 && showerAt < 0)) return;
      running = true; frame.last = 0;
      raf = window.requestAnimationFrame(frame);
    }
    function stop() { running = false; if (raf) window.cancelAnimationFrame(raf); raf = 0; }
    function drawStill() {
      g.clearRect(0, 0, W, H);
      drawStrands(99);
      for (var j = 0; j < landed.length; j++) { var r = landed[j]; paint(r, r.x, r.y, Math.max(0.5, r.lit), r.flat); }
    }

    measure();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) start(); else stop();
      }).observe(sec);
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (Math.abs(window.innerWidth - lastW) < 2 && Math.abs(cv.clientHeight - H) < 2) return;
      lastW = window.innerWidth;
      measure();
      if (!running) drawStill();
    });

    return {
      hang: function () { hungAt = performance.now(); rested = false; start(); },
      shower: function () { showerAt = performance.now(); lastSpawn = 0; rested = false; start(); },
      /* lit and still: the strings hanging, a few petals already at the foot */
      still: function () {
        still = true; stop();
        hungAt = 0;
        landed = [];
        var n = Math.round(total * 0.5);
        for (var i = 0; i < n; i++) { var p = petal(); p.x = rand(0.02, 0.98) * W; p.fx = p.x / W; p.y = floorY - rand(0, 12); p.lit = rand(0.5, 1); p.flat = rand(0.42, 0.62); landed.push(p); }
        drawStill();
      }
    };
  }

  /* ---------------- the opening ---------------- */
  function opening(sec) {
    if (sec.classList.contains('is-js')) return; /* the script is loaded by every Bridal section: once is enough */
    sec.classList.add('is-js');
    var air = null;
    try { air = Air(sec); } catch (e) { air = null; }
    var ol = sec.querySelector('.vrb-trip__arch--ol');
    var beats = beatsFor(!!ol && window.getComputedStyle(ol).display !== 'none');
    var all = function () { beats.forEach(function (b) { sec.classList.add(b[0]); }); if (air) air.still(); };
    var r = sec.getBoundingClientRect();
    if (reduce || r.bottom < 0 || r.top > window.innerHeight) { all(); return; }
    var started = false;
    var go = function () {
      if (started) return;
      started = true;
      beats.forEach(function (b) {
        window.setTimeout(function () {
          sec.classList.add(b[0]);
          if (b[0] === 'is-hung' && air) air.hang();
        }, b[1]);
      });
      window.setTimeout(function () { if (air) air.shower(); }, beats[beats.length - 1][1] + SHOWER_AFTER);
    };
    var img = sec.querySelector('.vrb-trip__arch--c img');
    if (!img || (img.complete && img.naturalWidth)) go();
    else {
      img.addEventListener('load', go, { once: true });
      img.addEventListener('error', go, { once: true });
    }
    window.setTimeout(go, 2500);
  }

  /* ---------------- the boxes ---------------- */
  function boxes(root) {
    var list = Array.prototype.slice.call(root.querySelectorAll('[data-vrb-box]'));
    if (reduce || !('IntersectionObserver' in window) || !list.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-open');
      });
    }, { rootMargin: '0px 0px -16% 0px', threshold: 0.08 });
    list.forEach(function (b) {
      if (b.getBoundingClientRect().top < window.innerHeight * 0.9) return; /* in view already: shown open */
      b.classList.add('is-armed');
      io.observe(b);
    });
  }

  /* ---------------- the shelves ---------------- */
  function rails(root) {
    root.querySelectorAll('[data-vrb-rail]').forEach(function (rail) {
      var row = rail.querySelector('[data-vrb-row]');
      if (!row) return;
      var prev = rail.querySelector('[data-vrb-go="-1"]'), next = rail.querySelector('[data-vrb-go="1"]');
      var update = function () {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) prev.hidden = row.scrollLeft <= 2;
        if (next) next.hidden = max <= 0 || row.scrollLeft >= max;
      };
      [prev, next].forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', function () {
          var d = +b.getAttribute('data-vrb-go');
          /* a box's row turns a whole page (four pieces); a shelf a little less than its width */
          var step = rail.hasAttribute('data-vrb-page') ? row.clientWidth + (parseFloat(getComputedStyle(row).columnGap) || 0) : row.clientWidth * 0.8;
          row.scrollBy({ left: d * step, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------- rising into place ---------------- */
  function rise(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-vrb-rise]'));
    if (reduce || !('IntersectionObserver' in window) || !els.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('is-armed');
      io.observe(el);
    });
  }

  var init = function () {
    document.querySelectorAll('[data-vrb-open]').forEach(opening);
    document.querySelectorAll('[data-vrb]').forEach(function (root) {
      if (root.dataset.vrbReady) return;
      root.dataset.vrbReady = '1';
      rise(root);
      boxes(root);
      rails(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
